export default {
    color: 'primary',

  }